import { useEffect, useState } from "react";
import axios from "axios";

const CalendarTab = ({ assignmentId }) => {
  const [cycles, setCycles] = useState([]);

  useEffect(() => {
    loadCycles();
  }, []);

  const loadCycles = async () => {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `http://localhost:5001/api/assignments/${assignmentId}/calendar`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setCycles(res.data);
  };

  return (
    <div className="bg-white border rounded-xl overflow-hidden">

      <table className="w-full text-sm">

        <thead className="bg-slate-50 text-slate-600">
          <tr>
            <th className="px-4 py-3 text-left">Service</th>
            <th className="px-4 py-3 text-left">Period</th>
            <th className="px-4 py-3 text-left">Due Date</th>
            <th className="px-4 py-3 text-left">Status</th>
          </tr>
        </thead>

        <tbody>
          {cycles.map(cycle => {

            const isOverdue =
              cycle.Status === "Pending" &&
              new Date(cycle.DueDate) < new Date();

            return (
              <tr key={cycle.CycleID} className="border-t">
                <td className="px-4 py-3">{cycle.ServiceName}</td>
                <td className="px-4 py-3">
                  {cycle.PeriodStart.split("T")[0]} → {cycle.PeriodEnd.split("T")[0]}
                </td>
                <td className="px-4 py-3">
                  {cycle.DueDate.split("T")[0]}
                </td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
                    isOverdue
                      ? "bg-red-100 text-red-700"
                      : cycle.Status === "Completed"
                      ? "bg-green-100 text-green-700"
                      : "bg-amber-100 text-amber-700"
                  }`}>
                    {isOverdue ? "Overdue" : cycle.Status}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>

      </table>

    </div>
  );
};

export default CalendarTab;
